import { memo, useState } from "react";
import { X, ZoomIn } from "lucide-react";

interface ChatImageProps {
  imageUrl: string;
  isOwnMessage: boolean;
}

const ChatImage = memo(({ imageUrl, isOwnMessage }: ChatImageProps) => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      <div 
        className="relative cursor-pointer group"
        onClick={() => setIsFullScreen(true)}
      >
        {isLoading && (
          <div className="w-48 h-48 bg-muted animate-pulse rounded-lg" />
        )}
        <img
          src={imageUrl}
          alt="Shared image"
          className={`max-w-[200px] max-h-[200px] rounded-lg object-cover ${isLoading ? "hidden" : ""}`}
          onLoad={() => setIsLoading(false)}
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors rounded-lg flex items-center justify-center">
          <ZoomIn className={`w-6 h-6 text-white opacity-0 group-hover:opacity-100 transition-opacity ${isOwnMessage ? "" : "text-foreground"}`} />
        </div>
      </div>

      {/* Full screen modal */}
      {isFullScreen && (
        <div 
          className="fixed inset-0 z-[70] bg-black/90 flex items-center justify-center p-4"
          onClick={() => setIsFullScreen(false)}
        >
          <button
            onClick={() => setIsFullScreen(false)}
            className="absolute top-4 right-4 p-2 rounded-full bg-white/20 text-white hover:bg-white/30 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
          <img
            src={imageUrl}
            alt="Full size"
            className="max-w-full max-h-full object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
});

ChatImage.displayName = "ChatImage";

export default ChatImage;
